import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
          <i className="ri-chat-heart-line text-sm"></i>
          瓜友热评
        </div>
        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
          吃瓜事件全民讨论
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {testimonials.slice(0, 5).map((t, idx) => {
          if (idx === 2) {
            return (
              <div key={t.id} className="relative rounded-2xl overflow-hidden h-full min-h-[240px]">
                <img
                  src={t.avatar}
                  alt={t.userName}
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-primary-900/90 via-primary-900/40 to-transparent">
                  <p className="text-white text-xs font-medium">{t.userName}</p>
                  <p className="text-white/60 text-[10px]">{t.role}</p>
                </div>
              </div>
            );
          }

          if (idx === 3) {
            return (
              <div key={t.id} className="md:col-span-2 relative rounded-2xl overflow-hidden h-full min-h-[240px]">
                <img
                  src={t.avatar}
                  alt={t.userName}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-900/85 via-primary-900/30 to-transparent flex flex-col justify-end p-6">
                  <p className="text-white/90 text-sm leading-relaxed mb-3 line-clamp-3">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <p className="text-white text-sm font-bold">{t.userName}</p>
                  <p className="text-white/60 text-xs">{t.role}</p>
                </div>
              </div>
            );
          }

          return (
            <div key={t.id} className="p-5 md:p-6 rounded-2xl bg-background-50">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.userName}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.userName}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="mb-3">
                <i className="ri-double-quotes-l text-2xl text-accent-300"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">&ldquo;{t.content}&rdquo;</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}